import { useEffect, useState } from 'react';

import {
  RINGCENTRAL_CALLBACK_CHANNEL,
  RingCentralCallbackMessage,
} from './ringCentralCallbackChannel';

/**
 * The page RingCentral returns the sign-in popup to. Rendered by src/index.tsx in place of the
 * whole app - see ringCentralCallbackChannel.ts. It passes RingCentral's answer to the window that
 * started the sign-in, which finishes the connection, and closes itself.
 */
export default function RingCentralCallback() {
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    const message: RingCentralCallbackMessage = {
      code: query.get('code'),
      state: query.get('state'),
      error: query.get('error_description') || query.get('error'),
    };

    const channel = new BroadcastChannel(RINGCENTRAL_CALLBACK_CHANNEL);
    channel.postMessage(message);
    channel.close();

    // Keep the single-use code out of the history and out of anything that reads the address bar.
    window.history.replaceState(null, '', window.location.pathname);

    window.close();
    // Still here: the browser would not let the page close its own window.
    setClosed(true);
  }, []);

  return (
    <p style={{ fontFamily: 'sans-serif', margin: 24 }}>
      {closed
        ? 'RingCentral has answered. You can close this window and go back to Compass Ag.'
        : 'Connecting RingCentral...'}
    </p>
  );
}
